/**
 * @generated SignedSource<<2e545032774859e71e365e0daf95cab2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KPIEditSectionsQuery$variables = {
  routineId: string;
};
export type KPIEditSectionsQuery$data = {
  readonly currentStore: {
    readonly " $fragmentSpreads": FragmentRefs<"KPIEditSectionsComponent_Store">;
  };
  readonly routine: {
    readonly " $fragmentSpreads": FragmentRefs<"KPIEditSectionsComponent_Routine">;
  } | null;
};
export type KPIEditSectionsQuery = {
  response: KPIEditSectionsQuery$data;
  variables: KPIEditSectionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KPIEditSectionsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "currentStore",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "KPIEditSectionsComponent_Store"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "KPIEditSectionsComponent_Routine"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KPIEditSectionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "includeArchived",
                "value": true
              }
            ],
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": "publicTeams(includeArchived:true)"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineSection",
            "kind": "LinkedField",
            "name": "activeSections",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "assignedTeam",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineVersion",
            "kind": "LinkedField",
            "name": "activeVersion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tasks",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TaskNumberGoals",
                        "kind": "LinkedField",
                        "name": "goals",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "greaterThan",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lessThan",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoutineSection",
                            "kind": "LinkedField",
                            "name": "section",
                            "plural": false,
                            "selections": (v3/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TaskNumber",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "efc580e65c42f03cd00b1bcd5536f077",
    "id": null,
    "metadata": {},
    "name": "KPIEditSectionsQuery",
    "operationKind": "query",
    "text": "query KPIEditSectionsQuery(\n  $routineId: ID!\n) {\n  currentStore {\n    ...KPIEditSectionsComponent_Store\n    id\n  }\n  routine(id: $routineId) {\n    ...KPIEditSectionsComponent_Routine\n    id\n  }\n}\n\nfragment KPIEditSectionsComponentSubItemListItem_Team on Team {\n  name\n  color\n}\n\nfragment KPIEditSectionsComponent_Routine on Routine {\n  id\n  activeSections {\n    id\n    title\n    assignedTeam {\n      id\n    }\n  }\n  activeVersion {\n    tasks {\n      id\n      __typename\n      ... on TaskNumber {\n        goals {\n          greaterThan\n          lessThan\n          section {\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment KPIEditSectionsComponent_Store on Store {\n  publicTeams(includeArchived: true) {\n    id\n    name\n    ...KPIEditSectionsComponentSubItemListItem_Team\n    ...KPIEditSectionsTeamListItem_Team\n    ...KPIEditSectionsSectionHeader_Team\n  }\n}\n\nfragment KPIEditSectionsSectionHeader_Team on Team {\n  color\n  icon\n  name\n}\n\nfragment KPIEditSectionsTeamListItem_Team on Team {\n  ...TeamIconCircleComponent_Team\n  name\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n"
  }
};
})();

(node as any).hash = "a0c8d569e85f06d889b0219040fd4657";

export default node;
